import styled from 'styled-components';

export const ObservationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  span {
    font-weight: 700;
  }
`;
